import { Paper, Tab, Typography } from "@mui/material";
import { lazy, useEffect } from "react";
import MyTabs from "src/components/layout/MyTabs/MyTabs";
import { VehicleIcon } from "src/components/icons/VehicleIcon";
import { PersonIcon } from "src/components/icons/PersonIcons";
import { useUserData } from "src/context/userContext";
import ProgressBar from "src/components/layout/Progress/ProgressBar";
import { useGridData } from "src/context/GridContext/GridContext";
import PrintButton from "src/components/buttons/PrintButton";
import { TabPanel } from "src/components/js/Statics";
import Report_KuljettajaTilaukset from "../components/Report_KuljettajaTilaukset";
import Report_AjoneuvoTilaukset from "../components/Report_AjoneuvoTilaukset";
import Report_DateSelector from "../components/Report_DateSelector";
import Report_SettingsButton from "../components/reportSettings/Report_SettingsButton";
import TilausTab_TabCell from "src/pages/steps/StepTilaus/TabTilaus/components/TilausTab_TabCell";
import { CapacityIcon } from "src/components/icons/ReportIcons";
import { useReportData } from "src/context/ReportContext";
import LazyLoader from "src/components/layout/Progress/LazyLoader";
import { PrintIcon } from "src/components/icons/ActionIcons";
import KuormakirjaTulosteetCore from "../../kuormakirjatulosteet/KuormakirjaTulosteetCore";

const Report_CapacityCore = lazy(() => import("../Report_Capacity/Report_CapacityCore"));

export default function ReportDailyLayout() {
  const { userAsiakas, auth } = useUserData();
  const { isLoading } = useGridData();
  const { tabValue, setTabValue } = useReportData();

  const handleTabChange = (event, newValue) => setTabValue(newValue);

  const numberOfAvailableTabs = [
    auth.page.report.daily.vehicle.read,
    auth.page.report.daily.driver.read,
  ].filter((x) => x).length;

  useEffect(() => {
    if (!auth.page.report.daily.vehicle.read && auth.page.report.daily.driver.read) {
      setTabValue(1);
    }
  }, [auth.page.report.daily.vehicle.read, auth.page.report.daily.driver.read]);

  return (
    <div>
      <div className="noPrint">
        <div style={{ display: numberOfAvailableTabs === 1 ? "none" : "initial" }}>
          <MyTabs value={tabValue} onChange={handleTabChange} centered>
            {auth.page.report.daily.vehicle.read && (
              <Tab
                value={0}
                key={0}
                label={
                  <TilausTab_TabCell
                    isActive={tabValue === 0}
                    title="Ajoneuvo"
                    subtitle="tilaukset"
                    icon={<VehicleIcon />}
                    tooltipTitle={""}
                  />
                }
              />
            )}
            {auth.page.report.daily.driver.read && (
              <Tab
                value={1}
                key={1}
                label={
                  <TilausTab_TabCell
                    isActive={tabValue === 1}
                    title="Kuljettaja"
                    subtitle="tilaukset"
                    icon={<PersonIcon />}
                    tooltipTitle=""
                  />
                }
              />
            )}
            {auth.page.report.daily.capacity.read && (
              <Tab
                value={2}
                key={2}
                label={
                  <TilausTab_TabCell
                    isActive={tabValue === 2}
                    title="Vapaa"
                    subtitle="kapasiteetti"
                    icon={<CapacityIcon />}
                    tooltipTitle=""
                  />
                }
              />
            )}
            {auth.page.report.daily.vehicle.read && (
              <Tab
                value={3}
                key={3}
                label={
                  <TilausTab_TabCell
                    isActive={tabValue === 3}
                    title="Kuormakirja"
                    subtitle="tulostus"
                    icon={<PrintIcon />}
                    tooltipTitle={""}
                  />
                }
              />
            )}
          </MyTabs>
        </div>
      </div>
      <Paper className="spaceBetween" style={{ flexWrap: "wrap", margin: "3px", padding: "3px" }}>
        <div
          className="onlyPrint"
          style={{
            paddingLeft: 10,
            display: "flex",
            gap: 4,
            alignItems: "center",
            justifyContent: "center",
          }}>
          <Typography variant="h6" className="fixPrint" noWrap>
            {userAsiakas?.asiakasNimi}
          </Typography>
        </div>
        <div style={{ flexGrow: 1 }}>
          <Report_DateSelector />
        </div>
        <div
          className="noPrint onlyWide"
          style={{
            display: "flex",
            gap: 4,
            flex: 1,
            justifyContent: "space-between",
          }}>
          <div>
            {tabValue !== 3 && (
              <PrintButton
                height={55}
                tooltipTitle="" // no tootip on print button, it will get printed
              />
            )}
          </div>
          <Report_SettingsButton />
        </div>
      </Paper>
      <ProgressBar show={isLoading} height={2} />
      {auth.page.report.daily.vehicle.read && (
        <TabPanel value={tabValue} index={0}>
          <Report_AjoneuvoTilaukset />
        </TabPanel>
      )}
      {auth.page.report.daily.driver.read && (
        <TabPanel value={tabValue} index={1}>
          <Report_KuljettajaTilaukset />
        </TabPanel>
      )}
      {auth.page.report.daily.capacity.read && (
        <TabPanel value={tabValue} index={2}>
          <LazyLoader>
            <Report_CapacityCore />
          </LazyLoader>
        </TabPanel>
      )}
      {auth.page.report.daily.vehicle.read && tabValue === 3 && (
        <TabPanel value={tabValue} index={3}>
          <KuormakirjaTulosteetCore />
        </TabPanel>
      )}
    </div>
  );
}
